import React from 'react';
import { sectionedPanelStyle } from '../../../../styles';
import { Spacer } from '@adserve/adserve-react-components';

const FigureCard = ({ title = '', figure = '', metric = '' }) => {

    const figureCardStyle = {
        ...sectionedPanelStyle,
        padding: '18px 30px 10px 30px',
        height: 153 + 29, // ASSP-7703 align height with Dapyparts
        boxSizing: 'border-box',
        width: '100%'
    };

    const titleStyle = {
        fontFamily: 'Roboto',
        fontSize: 17,
        color: '#414141',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 'bold'
    }

    const figureStyle = {
        fontFamily: 'Roboto',
        fontSize: 40,
        color: '#FF7D00',
        textDecoration: 'none solid rgb(65, 65, 65)',
        fontWeight: 'bold'
    }

    return (
        <div style={figureCardStyle}>
            <div>
                <span style={titleStyle}>
                    {title}
                </span>
            </div>

            <Spacer width={0} height={37 + 4} />

            <div>
                <span style={figureStyle}>
                    {`${figure} ${metric}`}
                </span>
            </div>
        </div>
    )

}

export default FigureCard;
